import classNames from 'classnames';
import dynamic from 'next/dynamic';
import * as React from 'react';
import Linkify from 'react-linkify';

import StringUtils from '../../../components/utils/StringUtils';

import css from './DescriptionPanel.module.scss';

// react-draft-wysiwygをそのまま使用するとReferenceError: window is not definedが発生するため
const RichViewer = dynamic(() => import('../../../components/RichViewer'), {
  ssr: false,
});

interface Props {
  description?: string;
  description_text?: string;
  is_json_description: boolean;
}

const MerchantCourseDetailsDescription = ({
  description,
  description_text,
  is_json_description,
}: Props) => {
  const classes = classNames(css.DescriptionPanel);

  return (
    <div className={classes}>
      {is_json_description && description ? (
        <RichViewer value={description} />
      ) : (
        description_text && (
          <Linkify>{StringUtils.simpleFormat(description_text)}</Linkify>
        )
      )}
    </div>
  );
};

export default MerchantCourseDetailsDescription;
